// `role`, `facilities` and `organizations` carry only identifiers: the server serializes relations as
// `{ id }` and never a label. The page resolves labels from the role/organization/facility lists it
// already loads. `organizations` is required: every response path serializes the
// `user-with-organizations` group, so the field is always present on the wire.
//
// `ssoIssuer` and `ssoSubject` are deliberately absent: they live behind the `user-sso` serialization
// group, requested by nobody on these routes. A field the server never sends must not be declared here
// — it would read as `undefined` with nothing to signal the mismatch.
export type UserPayload = {
	readonly id: number;
	readonly email: string;
	readonly firstName: string;
	readonly lastName: string;
	readonly isActive: boolean;
	readonly status: { readonly value: string; readonly label: string };
	readonly invitedAt: string | null;
	readonly activatedAt: string | null;
	readonly invitationExpiresAt: string | null;
	readonly hasMfaEnabled: boolean;
	readonly role: { readonly id: number } | null;
	readonly facilities: readonly { readonly id: number }[];
	readonly organizations: readonly { readonly id: number }[];
	readonly authenticationMode: { readonly value: string; readonly label: string };
	readonly ssoLinkedAt: string | null;
};

export type UsersListFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly UserPayload[];
};

export type UsersFetchedAction = {
	type: 'USERS_FETCHED';
	payload: UsersListFetchedPayload;
	accountId: number;
};

export default (payload: UsersListFetchedPayload, accountId: number): UsersFetchedAction => ({
	type: 'USERS_FETCHED',
	payload,
	accountId,
});
